import { array, is, string } from "superstruct"

import { getParameterFromUrl, isValidHttpUrl } from "utils/helpers"
import { CatalogSearchQuery } from "modules/PsyCatalog/common/searchQuery"
import { FRIENDLY_LABELS_NAME } from "components/Labels/constants"
import { uniq } from "utils/infrastructure/uniq"
import { isStorageAvailable, StorageWrapper } from "utils/infrastructure/storage-util"

function getFriendlyLabelsFromReferrer(referrer: string) {
    const isValidUrl = isValidHttpUrl(referrer)
    if (!isValidUrl) return

    const url = new URL(referrer)
    return url.searchParams.get(FRIENDLY_LABELS_NAME)
}

class _FriendlyLabelsStorage {
    localStorage?: StorageWrapper

    constructor() {
        this.localStorage = isStorageAvailable ? new StorageWrapper(window.localStorage) : undefined
    }

    storeFriendlyLabels(labels: string[]) {
        const updated = (this.getFriendlyLabels() ?? []).concat(labels)

        this.localStorage?.store(FRIENDLY_LABELS_NAME, uniq(updated))
    }

    saveFromFilters(workingWith: CatalogSearchQuery["working_with"]) {
        const arrayOfFriendlyLabels = Object.entries(workingWith)
            .filter(([, value]) => value)
            .map(([key]) => key)

        if (arrayOfFriendlyLabels.length === 0) {
            return
        }

        this.storeFriendlyLabels(arrayOfFriendlyLabels)
    }

    init(referrer: string) {
        const friendlyLabelsInUrl = getParameterFromUrl(FRIENDLY_LABELS_NAME)?.split(",")
        const friendlyLabelsInReferrer = getFriendlyLabelsFromReferrer(referrer)?.split(",")

        if (friendlyLabelsInUrl !== undefined) {
            this.storeFriendlyLabels(friendlyLabelsInUrl)
        }

        if (friendlyLabelsInReferrer !== undefined) {
            this.storeFriendlyLabels(friendlyLabelsInReferrer)
        }
    }

    getFriendlyLabels() {
        const storageLabels = this.localStorage?.get<string[]>(FRIENDLY_LABELS_NAME)
        return is(storageLabels, array(string()))
            ? storageLabels.map((label) => (label === "lgbt" ? "friendly" : label))
            : []
    }

    get isAnyLabelEnabled() {
        return this.getFriendlyLabels().length > 0
    }

    hasFriendlyLabel(key: string) {
        return Boolean(this.getFriendlyLabels().includes(key))
    }
}

export const FriendlyLabelsStorage = new _FriendlyLabelsStorage()
